import engineUserAgent from './engine-user-agent.js';

var userAgent = engineUserAgent;
var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
var engineWebkitVersion = !!webkit && +webkit[1];

export { engineWebkitVersion as default };
